import script from "./topBar.vue?vue&type=script&setup=true&lang=js"
export * from "./topBar.vue?vue&type=script&setup=true&lang=js"

import "./topBar.vue?vue&type=style&index=0&id=ecfa1994&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecfa1994"]])

export default __exports__